/**
 * Pure helpers for /api/get_offer_data/ list mode (import dialog search).
 */

export function resolveOfferListClientName(offer) {
    if (offer?.client?.full_name) return offer.client.full_name;
    if (offer?.client_data?.full_name) return offer.client_data.full_name;
    return "";
}

export function resolveOfferListLocationDescription(offer) {
    if (offer?.location?.description) return offer.location.description;
    if (offer?.location_data?.description) return offer.location_data.description;
    if (offer?.location_description) return offer.location_description;
    return "";
}

export function buildImportOfferListParams({
    page,
    itemsPerPage,
    selectedImportTypeCode,
    importSearch,
    importOfferId,
}) {
    const params = {
        list: 1,
        page,
        itemsPerPage,
        sortKey: "modified",
        sortDir: "desc",
    };
    if (selectedImportTypeCode != null) {
        params.offerType = selectedImportTypeCode;
    }
    if ((importSearch || "").trim()) {
        params.clientName = importSearch.trim();
    }
    if ((importOfferId || "").toString().trim()) {
        params.searchId = (importOfferId || "").toString().trim();
    }
    return params;
}

export function withImportListClientNames(offers) {
    return offers.map(offer => ({
        ...offer,
        client_name: resolveOfferListClientName(offer),
        location_description: resolveOfferListLocationDescription(offer),
    }));
}

export function isCompositeSuboffer(offer) {
    return offer?.composite_offer_id != null;
}

export function buildImportOfferListRows(payload) {
    const offers = payload?.offers || [];
    const compositeOffers = payload?.composite_offers || [];
    const standaloneOffers = offers.filter(offer => !isCompositeSuboffer(offer));
    const importableCompositeOffers = compositeOffers.map(composite => ({
        ...composite,
        // Keep CO... as visible id, but use first suboffer numeric id for import payload fetch.
        import_source_offer_id: composite?.offers?.[0]?.id || null,
    }));
    return [...standaloneOffers, ...importableCompositeOffers];
}
